<template>
  <div class='h-100 '>

    <TraceMap :tracableInfo='tracableInfo' style='height:300px' ref='mapcom'
              mapId='history'
              :key="'history'"></TraceMap>
    <!--    <Map v-else style='height: 300px'></Map>-->
    <div class='uk-flex-1'>
      <div class='uk-flex uk-flex-between uk-margin-small-top uk-margin-small-bottom'>
        <div>{{ $t('integration.detailed_information') }}</div>
        <div @click='carrierDetail(tracableInfo.carrier.id, tracableInfo.carrier.keycode, tracableInfo.carrier.typeId)'
             class='cursor-pointer'>more >>
        </div>
      </div>
    </div>
    <div class='uk-flex w-100 border' style='height:calc(100% - 20px);'>
      <div style='width:50%;border-right: #ccc solid 1px;'>
        <div style='height:calc(100%);'>
          <div class='uk-text-center carrier-img-title'
               style='border-bottom:1px #ccc solid; padding: 10px 0;font-weight: 600;'>{{ tracableInfo.carrier.keycode
            }}
          </div>
          <div style='padding:5px 10px;height: calc(100% - 50px);'>
            <div class='h-100'>
              <CarrierInfoImg :carrier='tracableInfo.carrier'
                              :tab.sync='tracableInfo.carrier.alarm_switch'></CarrierInfoImg>
            </div>
          </div>
        </div>
      </div>
      <HistoryTraceNormalInfo
        v-if='tracableInfo.carrier.mode === 1'
        :tracableInfo='tracableInfo'
        :detailInfo.sync='detailInfo'
        :filterOptionList='filterOptionList'
        :pointInfo='pointInfo'
        :mapCom='$refs.mapcom'>
      </HistoryTraceNormalInfo>
      <HistoryTransportInfo
        v-else-if='tracableInfo.carrier.mode === 2'
        :tracableInfo='tracableInfo'
        :detailInfo.sync='detailInfo'
        :filterOptionList='filterOptionList'
        :pointInfo='pointInfo'
        :mapCom='$refs.mapcom'>
      </HistoryTransportInfo>
    </div>
  </div>
</template>
<script>
import CarrierInfoImg from '@/pages/dataBoard/MonitoringPoint/component/DisplayArea/component/component/CarrierInfoImg'
import { carrierDetail } from '@/utils/winDetail'
import { mapTrackTraceDetail } from '@/api/modules/map'
import bus from '@/utils/bus'
import { traceFilterOptions } from '@/api/modules/home'
import TraceMap from '../TraceMap.vue'
import HistoryTraceNormalInfo from '@/pages/dataBoard/mapMonitor/components/ArchDetail/trace/HistoryTraceNormalInfo.vue'
import HistoryTransportInfo from '@/pages/dataBoard/mapMonitor/components/ArchDetail/trace/HistoryTransportInfo.vue'
import Map from '@/components/Map/Map.vue'

export default {
  props: ['tracableInfo'],
  components: {
    Map,
    HistoryTransportInfo,
    HistoryTraceNormalInfo,
    CarrierInfoImg,
    TraceMap
  },
  data () {
    return {
      carrierDetail,

      detailInfo: null,
      filterOptionList: [],
      // 轨迹点信息
      pointInfo: null
    }
  },
  methods: {

    initFilterOptions () {
      traceFilterOptions({
        code: 'trace_filter',
        type: 0
      }).then(res => {
        this.filterOptionList = res.result
      })
    }
  },
  mounted () {
    // 海量点被点击 携带点击数据
    bus.$on('massClick', info => {
      mapTrackTraceDetail({
        id: info.id,
        time: info.time
      }).then(res => {
        res.result.state.time = info.time
        this.detailInfo = res.result.state
        this.pointInfo = info
      })
    })

    // 初始化过滤器选项
    this.initFilterOptions()
  }
}
</script>

<style scoped lang='scss'>
// 速度筛选器
.filter-speed {
  .to {
    width: 50px;
    text-align: center;
    border-top: #ccc solid 1px;
    border-bottom: #ccc solid 1px;
  }

  ::v-deep .el-input {
    width: 70px;
  }
}
</style>
